// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-headline {
  width: 100%;
  background-color: transparent;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  padding: 8px 16px;
  text-align: left;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
}

.news-headline .news-headline-container {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.news-headline .headline {
  /* 3 lines * 24px line-height */
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;

  /* Multi-line ellipsis for 3 lines */
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

.news-headline .datetime {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: right;
  color: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/Components/News/NewsList.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;EAEjB,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B","sourcesContent":[".news-headline {\n  width: 100%;\n  background-color: transparent;\n  border: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  padding: 8px 16px;\n  text-align: left;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n}\n\n.news-headline .news-headline-container {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.news-headline .headline {\n  /* 3 lines * 24px line-height */\n  color: var(--text-primary);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n\n  /* Multi-line ellipsis for 3 lines */\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n\n.news-headline .datetime {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  text-align: right;\n  color: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
